<template>
    <div>
      <iframe :src="pdfUrl" width="100%" height="500px"></iframe>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      pdfUrl: {
        type: String,
        required: true
      }
    }
  };
  </script>
  